import { graphql } from "@/lib/gql/__generated__";

export const RESERVATION_DETAIL_UPDATE_MAIL_MAGAZINE_STATUS_FOR_MANAGEMENT_RESERVATION_ITEM_DETAIL_UPDATE_MUTATION =
	graphql(/* GraphQL */ `
		mutation ReservationDetailUpdateMailMagazineStatusForManagementReservationItemDetailUpdate(
			$input: ReservationDetailUpdateMailMagazineStatusInput!
		) {
			reservationDetailUpdateMailMagazineStatus(input: $input) {
				reservationDetail {
					isMailMagazineAccept
				}
				userErrors
			}
		}
	`);
